var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldWrapper',{attrs:{"field":_vm.field}},[_c('button',{staticClass:"btn",class:[_vm.colorClass, { 'spinner spinner-white spinner-right': _vm.running }],attrs:{"disabled":(_vm.running && !_vm.cancelable) || _vm.isDisabled},on:{"click":_vm.onAction}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }